import axios from "axios";
import AuthService from "../../AuthService";

class FileUploadService {
    async upload(bateauId, file, onUploadProgress) {
        let formData = new FormData();

        formData.append("bateauId", bateauId);
        formData.append("file", file);

        return await axios.post(AuthService.getUrl("/upload"), formData, AuthService.getAuthHeaderUpload(null, onUploadProgress));
    }
}

export default new FileUploadService();
